module.exports = __webpack_public_path__ + "img/twitter.f114234e.svg";